<template>
  <div class="mb-4 ">
    <CCard class="bg-style2">
<!--      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">-->
<!--        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption.filter(obj => { return (obj.key == lang) })[0].value }} </span>-->
<!--      </CCardHeader>-->
      <CCardBody>
        <IDPProfile/>
        <CRow  v-for="(objsI,index) in idp.item" :key="objsI._id">
          <CCol col="12">
            <CCard class="bg-style2 mb-4">
              <CCardHeader class="bg-gradient-dark text-white" >
                <span class="font-weight-bold h6"> <CIcon name="cil-bookmark" class="mr-2"/> <label class="font-weight-bold">{{ objsI.title.filter(item => { return (item.key === lang)})[0].value }} </label> </span>
              </CCardHeader>
              <CCardBody >
                <CRow>
                  <CCol col="12" v-if="objsI.description.length > 0">
                    <div v-html="objsI.description.filter(item => { return (item.key === lang)})[0].value"></div>
                  </CCol>

                  <CCol col="12">
                    <IDPInfomation :idp="objsI.item" :index="index" @update="onChangeCC"/>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
<!---->
        </CRow>

        <CRow >
          <CCol class="text-right">
            <CButton v-if="buttom.isSave" class="ml-2" size="sm" color="success" shape="pill" variant="outline" @click="onSave">
              <span class="font-weight-bold pr-1"><CIcon name="cil-save"/> {{ $t('save') }} </span>
            </CButton>

            <CButton v-if="buttom.isSend" class="ml-2" size="sm" color="info" shape="pill" variant="outline" @click="onSend">
              <span class="font-weight-bold pr-1"><CIcon name="cil-hand-point-up"/> {{ $t('send') }} </span>
            </CButton>

            <CButton v-if="buttom.isUnSend" class="ml-2" size="sm" color="danger" shape="pill" variant="outline" @click="onUnSend">
              <span class="font-weight-bold pr-1"><CIcon name="cil-hand-point-up"/>  {{ $t('unsend') }} </span>
            </CButton>

            <CButton v-if="buttom.isRejected"  class="ml-2" size="sm" color="dark" shape="pill" variant="outline" @click="onRejected">
              <span class="font-weight-bold pr-1"><CIcon name="cil-loop-circular"/> {{ $t('reject') }} </span>
            </CButton>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>


  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";
import IDPHistory from "@/projects/views/E-Performances/Estimate/components/sub/IDPHistorys";
import IDPProfile from "@/projects/views/E-Performances/Estimate/components/sub/IDPProfile.vue";
import IDPInfomation from "@/projects/views/E-Performances/Estimate/components/sub/IDPInfomation.vue";
moment.locale('th')

export default {
  name: 'IDP',
  components: {IDPInfomation, IDPProfile, IDPHistory},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Individual Development Plan'
    },
    options: {
      type: Object,
      default: null
    }

  },

  data: function () {
    return {
      horizontal: { label:'col-3', input:'col-9' },
      collapseDuration: 0,
      idp : {},

      buttom:{
        isSave : false,
        isSend : false,
        isUnSend : false,
        isRejected : false,

      }

    }
  },

  mounted() {

  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {

    onInit() {
      this.$store.dispatch("agency/config",{})
      this.$store.dispatch("idp/method",{})
      this.onLoad();
    },

    onLoad() {
      // this.idp = {}
      this.idp = this.$store.getters['idp/idp'];


      this.onCheckState();

    },
    onSave() {

      // var body = this.objs;
      // body.item = this.idp.item;
      //
      // console.log(body)
      //
      // this.$store.dispatch("idp/config",body);

      var body = {};
      body._id = this.idp._id;
      body.status = 0;
      body.year = this.options.year;

      body.item = this.idp.item;



      // console.log(this.$store.getters['personal/profile']._id,'body',body);

      this.$store.dispatch("idp/config",body);


    },
    onSend() {
      var body = {};
      body._id = this.idp._id;
      body.status = 1
      body.year = this.options.year;

      body.item = this.idp.item;
      // this.$store.dispatch("idp/config",body);
    },
    onUnSend() {},
    onRejected() {},


    onChangeCC(value, index) {
      this.idp.item[index].item  = value
    },

    onCheckState() {
      this.buttom.isSave = false;
      this.buttom.isSend = false;
      this.buttom.isUnSend = false;
      this.buttom.isRejected = false;


      if (this.$store.getters['idp/idp'].status.at(-1).state._id.toString() == "6723709ab9a2030e40d1b884") {
        this.buttom.isSave = true;
      }

      if (this.$store.getters['idp/idp'].status.at(-1).state._id.toString() == "654851a37ab25be71bbeeed6") {
        this.buttom.isSave = true;
      }
      // สามารถทำการ บันทึกได้

      if (this.$store.getters['idp/idp'].status.at(-1).state._id.toString() == "654851dbe41b7f46025977f6") {
        this.buttom.isSave = true;
        this.buttom.isSend = true;
      }
      // สามารถทำการ ส่งได้
      if (this.$store.getters['idp/idp'].status.at(-1).state._id.toString() == "654851ece41b7f46025977fa") {
        this.buttom.isUnSend = true;
      }


      if (this.$store.getters['idp/idp'].status.at(-1).state._id.toString() == "670f777373effdb76e17954d") {
        this.buttom.isSave = true;
        this.buttom.isSend = true;
      }

      // เปรียบเทียบ

      // ยอมรับ

      // ไม่ยอมรับ

    },


  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {
    lang(value){
    }
  }
}
</script>
<style>

.a4-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.a4 {
  width: 210mm; /* ความกว้าง */
  height: 297mm; /* ความสูง */
  border: 1px solid #000; /* แสดงขอบกระดาษเพื่อให้มองเห็นได้ */
  padding: 20px;
  background: #fff;
  margin: 10px auto; /* จัดกึ่งกลาง */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* เพิ่มเงา */
  overflow: hidden; /* ซ่อนส่วนเกิน */
}

.page-content {
  overflow: visible; /* เนื้อหาแสดงผลทั้งหมดก่อนจัดหน้า */
}
.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
